import "./App.css";
import { useState, useEffect } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import LandingPage from "./Pages/LandingPage/LandingPage";
import FeaturePage from "./Pages/FeaturePage/FeaturePage";
import PricingPage from "./Pages/PricingPage/PricingPage";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage/PrivacyPolicyPage.js";
import IndustriesPage from "./Pages/IndustriesPage/IndustriesPage";
import { client } from "./lib/SanityConfig";
import {
  fetchHeaderSection,
  fetchHeroSection,
  fetchBannerSection,
  fetchRealtimeWorkflow,
  fetchHomeFeaturesSection,
  fetchHomeSlider,
  fetchYourAdvantage,
  fetchNMTestimonial,
  fetchFAQSection,
  fetchFooterSection,
  fetchNMFeatureHero,
  fetchNMTabSection,
  fetchNMInCallFeatures,
  fetchNMPostCallFeatures,
  fetchNMCuttingEdge,
  fetchNMPreCallFeatures,
  fetchSmarterReception,
  fetchPricing,
} from "./lib/SanityQuery";
import Loader from "./Components/Loader/Loader";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import useCountryCode from "./hook/useCountryCode";
import App2 from "../src/FreeUser/LandingPage/App2";
import { useSearchParams } from "react-router-dom";
import PricingPopup from "./Components/PricingPopup/PricingPopup";
import { loadRexWidgetScript } from "./lib/rexWidget.js";
import { useLocation } from "react-router-dom";
import GetInvolved from "./GetInvolved/GetInvolved.jsx";
import ScrollToTop from "./hook/ScrolltoTop.jsx";
import TermsPage from "./Pages/TermsPage/TermsPage.js";
import NotFound from "./Components/Notfound/NotFound.jsx";
import QuickAgentSetup from "./QuickAgent/QuickAgent.jsx";
import QuickAgentSetup2 from "./QuickAgent2/QuickAgent2.jsx";
function MainLayout({ header, footerData, onBannerClick }) {
  return (
    <>
      <Navbar header={header} onBannerClick={onBannerClick} />
      <Outlet />
      <Footer fetchFooterdata={footerData} />
    </>
  );
}

function FreeUserLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

function GetInvolvedPage() {
  return (
    <>
      <Outlet />
    </>
  );
}

function QuickAgent() {
  return (
    <>
      <Outlet />
    </>
  );
}

function QuickAgent2() {
  return (
    <>
      <Outlet />
    </>
  );
}

function App() {
  const location = useLocation();
  const { country } = useCountryCode();
  const [header, setHeader] = useState(null);
  const [hero, setHero] = useState(null);
  const [banner, setBanner] = useState(null);
  const [rexptWorkFlow, setRexptWorkFlow] = useState(null);
  const [HomeFeature, setHomeFeature] = useState(null);
  const [testimonialdata, settestimonial] = useState(null);
  const [fetchYourAdvantagedata, setfetchYourAdvantagedata] = useState(null);
 const [fetchNMTestimonialdata, setfetchNMTestimonial] = useState(null);
  const [featureHero , setFeatureHero] = useState(null);
  const [fetchFooterdata, setFooterData] = useState(null);
  const [fetchInCall, setFetchInCall] = useState(null);
  const [fetchFaq, setFaq] = useState(null);
  const [featureTab, setFeatureTab] = useState(null);
  const [PostCallFeaturedata, setpostcallfeaturedata] = useState(null);
  const [fetchNMCuttingEdgedata, setfetchNMCuttingEdgedata] = useState(null);
  const [preCallfeaturedata, setprecallfeaturedata] = useState(null);
  const [smarterReceptiondata, setSmartReceptiondata] = useState(null);
  const [pricingData, setPricingdata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPlanName, setSelectedPlanName] = useState(null);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const handleBannerClick = () => setShowPricingModal(true);
  const [searchParams] = useSearchParams();

  // useEffect(() => {
  //   let cancelled = false;
  //   const isGetInvolvedPage = location.pathname === "/get_involved";
  //   const agentId = isGetInvolvedPage
  //     ? "agent_0498e1599d6ea9e13d09657f79"
  //     : "agent_0498e1599d6ea9e13d09657f79";
  //   loadRexWidgetScript({
  //     agentId,
  //     defer: true,
  //   }).then((rex) => {
  //     if (cancelled) return;

  //     const isPricingPage = location.pathname === "/pricing";
  //     const isMobile = window.matchMedia("(max-width: 768px)").matches;
  //     const btn = document.getElementById("agentButton");

  //     if (isPricingPage && isMobile) {
  //       rex?.hide?.();
  //       if (btn) btn.style.display = "none";
  //     } else {
  //       rex?.show?.();
  //       if (btn) btn.style.display = "block";
  //     }
  //   });

  //   return () => {
  //     cancelled = true;
  //   };
  // }, []);

  const KNOWN_ROUTES = [
    "/",
    "/features",
    "/pricing",
    "/industries",
    "/free_signup",
    "/get_involved",
  ];


  

  useEffect(() => {
    let cancelled = false;
    const isGetInvolvedPage = location.pathname === "/get_involved";
    const agentId = isGetInvolvedPage
      ? "21ZW4Y"
      : "agent_0498e1599d6ea9e13d09657f79";

    const widgetUrl = isGetInvolvedPage
      ? "https://app.rxpt.ai/widget-x.js"
      : "https://rexpt-chat-widget.vercel.app/index.js";


      
    loadRexWidgetScript({
      agentId,
      defer: true,
      widgetUrl,
    }).then((rex) => {
      if (cancelled) return;
      const isPricingPage = location.pathname === "/pricing";
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const btn = document.getElementById("agentButton");
      if (isPricingPage && isMobile) {
        rex?.hide?.();
        if (btn) btn.style.display = "none";
      } else {
        rex?.show?.();
        if (btn) btn.style.display = "block";
      }
    });

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  useEffect(() => {
    const isPricingPage = location.pathname === "/pricing";
    const isGetInvolvedPage = location.pathname === "/get_involved";
    const isKnownRoute = KNOWN_ROUTES.includes(location.pathname);
    const isNotFoundPage = !isKnownRoute;
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const btn = document.getElementById("agentButton");
    if ((isPricingPage && isMobile) || isGetInvolvedPage || isNotFoundPage) {
      document.body.classList.add("hide-rex-widget");
    } else {
      document.body.classList.remove("hide-rex-widget");
    }
    if (btn) {
      if ((isPricingPage && isMobile) || isGetInvolvedPage) {
        btn.style.display = "none";
      } else {
        btn.style.display = "block";
      }
    }
    if (window.REX) {
      if ((isPricingPage && isMobile) || isGetInvolvedPage) {
        window.REX.hide?.();
      } else {
        window.REX.show?.();
      }
    }
  }, [location.pathname]);

  const discountToPlanMap = {
    90: "Starter",
    225: "Scaler",
    450: "Growth",
    700: "Corporate",
  };

  useEffect(() => {
    const isUsingVPN = country === "US";
    const open = searchParams.get("open");
    if (isUsingVPN) {
      if (open && open.endsWith("-OFF")) {
        const match = open.match(/^(\d+)-OFF$/);
        const discountValue = match ? parseInt(match[1], 10) : null;
        if (discountValue) {
          const mappedPlan = discountToPlanMap[discountValue];
          if (mappedPlan) {
            setSelectedPlanName(mappedPlan);
            setShowPricingModal(true);
          }
        }
      }
    } else {
      if (open && open.endsWith("-OFF")) {
        const match = open.match(/^(\d+)-OFF$/);
        const discountValue = match ? parseInt(match[1], 10) : null;
        if (discountValue) {
          const mappedPlan = discountToPlanMap[discountValue];
          if (mappedPlan) {
            setSelectedPlanName(mappedPlan);
            setShowPricingModal(true);
          }
        }
      } else {
        setShowPricingModal(false);
      }
    }
  }, [searchParams, country]);

  const handleClosePricing = () => {
    setShowPricingModal(false);
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [
          headerData,
          heroData,
          bannerData,
          RexptWorkFlow,
          HomeFeatureData,
          testimonial,
          fetchYourAdvantagedata,
          fetchClienttestimonial,
          fetchFaqData,
          fetchFooter,
          featureHeroData,
          featureTabData,
          fetchInCallData,
          fetchpostcalldata,
          CuttingEdgeData,
          preCallFeatures,
          smartRecept,
          fetchPricingdata,
        ] = await Promise.all([
          client.fetch(fetchHeaderSection),
          client.fetch(fetchHeroSection),
          client.fetch(fetchBannerSection),
          client.fetch(fetchRealtimeWorkflow),
          client.fetch(fetchHomeFeaturesSection),
          client.fetch(fetchHomeSlider),
          client.fetch(fetchYourAdvantage),
          client.fetch(fetchNMTestimonial),
          client.fetch(fetchFAQSection),
          client.fetch(fetchFooterSection),
          client.fetch(fetchNMFeatureHero),
          client.fetch(fetchNMTabSection),
          client.fetch(fetchNMInCallFeatures),
          client.fetch(fetchNMPostCallFeatures),
          client.fetch(fetchNMCuttingEdge),
          client.fetch(fetchNMPreCallFeatures),
          client.fetch(fetchSmarterReception),
          client.fetch(fetchPricing),
        ]);
        if (!alive) return;
        setHeader(headerData ?? null);
        setHero(heroData ?? null);
        setBanner(bannerData ?? null);
        setRexptWorkFlow(RexptWorkFlow ?? null);
        setHomeFeature(HomeFeatureData ?? null);
        settestimonial(testimonial ?? null);
        setfetchYourAdvantagedata(fetchYourAdvantagedata ?? null);
        setfetchNMTestimonial(fetchClienttestimonial ?? null);
        setFaq(fetchFaqData ?? null);
        setFooterData(fetchFooter ?? null);
        setFeatureHero(featureHeroData ?? null);
        setFeatureTab(featureTabData ?? null);
        setFetchInCall(fetchInCallData ?? null);
        setpostcallfeaturedata(fetchpostcalldata ?? null);
        setfetchNMCuttingEdgedata(CuttingEdgeData ?? null);
        setprecallfeaturedata(preCallFeatures ?? null);
        setSmartReceptiondata(smartRecept ?? null);
        setPricingdata(fetchPricingdata ?? null);
      } catch (err) {
        if (!alive) return;
        setError(err?.message || "Failed to fetch content");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (loading) return <Loader />;
  if (error) return <div className="App"></div>;

  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route
          element={
            <MainLayout
              header={header}
              footerData={fetchFooterdata}
              onBannerClick={handleBannerClick}
            />
          }
        >
          <Route
            path="/"
            element={
              <LandingPage
                hero={hero}
                banner={banner}
                rexptWorkFlow={rexptWorkFlow}
                HomeFeature={HomeFeature}
                testimonialdata={testimonialdata}
                fetchYourAdvantagedata={fetchYourAdvantagedata}
                fetchNMTestimonialdata={fetchNMTestimonialdata}
                fetchFaq={fetchFaq}
              />
            }
          />
          <Route
            path="/features"
            element={
              <FeaturePage
                featureHero={featureHero}
                featureTab={featureTab}
                fetchInCall={fetchInCall}
                PostCallFeaturedata={PostCallFeaturedata}
                fetchNMCuttingEdgedata={fetchNMCuttingEdgedata}
                preCallfeaturedata={preCallfeaturedata}
                smarterReceptiondata={smarterReceptiondata}
              />
            }
          />
          <Route
            path="/pricing"
            element={
              <PricingPage pricingData={pricingData} country={country} />
            }
          />
          <Route
            path="/industries"
            element={<IndustriesPage banner={banner} />}
          />
          <Route
            path="/terms-condition"
            element={
              <TermsPage
                header={header}
                isVisible="false"
                footerData={fetchFooterdata}
              />
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <PrivacyPolicyPage
                header={header}
                isVisible="false"
                footerData={fetchFooterdata}
              />
            }
          />

        </Route>
        <Route element={<FreeUserLayout />}>
          <Route path="/free_signup" element={<App2 />} />
        </Route>

        <Route element={<GetInvolvedPage />}>
          <Route path="/get_involved" element={<GetInvolved />} />
        </Route>

        <Route element={<QuickAgent />}>
          <Route path="/Quick-agent/:agentId" element={<QuickAgentSetup/>} />
        </Route>
        <Route element={<QuickAgent2 />}>
          <Route path="/Quick_agent/:agentId" element={<QuickAgentSetup2/>} />
        </Route>

        <Route
          path="*"
          element={<NotFound header={header} isVisible="false" />}
        />
      </Routes>

      {showPricingModal && (
        <PricingPopup
          isOpen={showPricingModal}
          onClose={handleClosePricing}
          selectedPlanName={selectedPlanName}
          countryCode={country}
          isYearlys={true}
        />
      )}
    </div>
  );
}

export default App;
